import moment from 'moment'

/**
 * @member {moment} date_of_expire
 * @member {String} document_type
 * @member {String} filename
 * @member {String} type
 * @member {String} uuid
 */
export default class UppyFileMeta {
  date_of_expire
  document_type
  filename
  type
  uuid

  /**
   * @param {moment|null} date_of_expire
   * @param {String} document_type
   * @param {String} filename
   * @param {String} type
   * @param {String} uuid
   */
  constructor({
    date_of_expire,
    document_type,
    filename,
    type,
    uuid
  }) {
    const properties = {
      configurable: false,
      enumerable: true,
      writable: true
    }

    const momentDateOfExpire = moment(date_of_expire, 'DD.MM.YYYY')

    date_of_expire = momentDateOfExpire.isValid() ? momentDateOfExpire : null
    document_type = String(document_type)
    filename = String(filename)
    type = String(type)
    uuid = String(uuid)

    Object.defineProperty(this, 'date_of_expire', Object.assign({ value: date_of_expire }, properties))
    Object.defineProperty(this, 'document_type', Object.assign({ value: document_type }, properties))
    Object.defineProperty(this, 'filename', Object.assign({ value: filename }, properties))
    Object.defineProperty(this, 'uuid', Object.assign({ value: uuid }, properties))

    Object.defineProperty(this, 'type', Object.assign({
      configurable: false,
      enumerable: true,
      get: () => type,
      set: function(type) {
        // Prevents Uppy From setting data in Uppy._checkAndCreateFileStateObject2
      }
    }))

    Object.defineProperty(this, 'name', Object.assign({
      configurable: false,
      enumerable: true,
      get: () => filename,
      set: function(name) {
        // Prevents Uppy From setting data in Uppy._checkAndCreateFileStateObject2
      }
    }))

    Object.freeze(this)
  }
}
